import * as RadixSelect from '@radix-ui/react-select'
import { FC } from 'react'
import { styled } from '../../../config'
import { Icons } from '../../../index'
import { scrollButtonStyles } from '../constants'

export interface SelectScrollUpButtonProps extends RadixSelect.SelectScrollUpButtonProps {}

const StyledSelectScrollUpButton = styled(RadixSelect.ScrollUpButton, scrollButtonStyles)

export const SelectScrollUpButton: FC<SelectScrollUpButtonProps> = (props) => {
  return (
    <StyledSelectScrollUpButton {...props}>
      <Icons.ChevronUp />
    </StyledSelectScrollUpButton>
  )
}
